import { Roles } from './roles';

export class Rol {
  roles: Roles[];
}
